import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

// ── SSO Landing Page ─────────────────────────────────────────────────────────
const SsoPage = () => {
  const { ssoLogin } = useAuth();
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setErrorMsg('Kein SSO-Token in der URL gefunden.');
      return;
    }
    ssoLogin(token).then(result => {
      if (result.success) {
        window.history.replaceState({}, '', '/');
        setStatus('success');
        setTimeout(() => window.location.replace('/'), 300);
      } else {
        setStatus('error');
        setErrorMsg(result.error || 'Ungültiger oder abgelaufener Link');
      }
    });
  // Run once on mount – no deps needed
  // eslint-disable-next-line
  }, []);

  if (status === 'loading') {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-blue-400 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-white text-sm font-medium">Anmeldung läuft…</p>
        </div>
      </div>
    );
  }
  if (status === 'success') {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="text-center">
          <svg className="w-12 h-12 text-emerald-400 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="text-white font-medium">Erfolgreich angemeldet – Weiterleitung…</p>
        </div>
      </div>
    );
  }
  // Error state
  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-sm w-full text-center">
        <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          </svg>
        </div>
        <h2 className="text-lg font-bold text-slate-900 mb-2">Link ungültig</h2>
        <p className="text-sm text-slate-500 mb-6">{errorMsg}</p>
        <a href="/"
          className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-medium text-sm px-6 py-2.5 rounded-lg transition-colors"
          data-testid="sso-error-login-btn">
          Zum Login
        </a>
      </div>
    </div>
  );
};

export default SsoPage;
